import { BoardContainer } from "./scenes/board-scene/board-container/BoardContainer";
import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { AudioManager } from "./AudioManager";

export class GameManager {

    public static init(): void {

        GameManager.initGameDistributionSDK();

        GameVars.cards = [];

        const nav = <any> navigator;
        let userLang = nav.language || nav.userLanguage;

        if (userLang.indexOf("de") !== -1) {
            GameVars.language = GameConstants.GERMAN;
        } else {
            GameVars.language = GameConstants.ENGLISH;
        }

        GameManager.generateCardValues();

        GameManager.readGameData();
    }

    public static initGameDistributionSDK(): void {

        window["GD_OPTIONS"] = {
            "gameId": "9cbd658c4edf4f3283e54337f080f341",
            "onEvent": function(event: any): any {
                switch (event.name) {
                    case "SDK_GAME_START":
                        if (!GameVars.gameData.musicMuted) {
                            AudioManager.music.mute(false);
                        }
                        if (!GameVars.gameData.soundMuted) {
                            AudioManager.sound.mute(false);
                        }

                        GameVars.currentScene.scene.start("BoardScene");
                        
                        break;
                    case "SDK_GAME_PAUSE":
                        if (!GameVars.gameData.musicMuted) {
                            AudioManager.music.mute(true);
                        }
                        if (!GameVars.gameData.soundMuted) {
                            AudioManager.sound.mute(true);
                        }
                        break;
                    case "SDK_GDPR_TRACKING":
                        console.log("SDK_GDPR_TRACKING");
                        break;
                    case "SDK_GDPR_TARGETING":
                        console.log("SDK_GDPR_TARGETING");
                        break;
                    default:
                        break;
                }
            },
        };
        (function(d: any, s: any, id: any): any {
            var js: any, fjs: any = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://html5.api.gamedistribution.com/main.min.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "gamedistribution-jssdk"));
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {

                    GameVars.gameData = {
                        soundMuted: false,
                        musicMuted: false,
                        genre: GameConstants.GENDER_MALE,
                        id: 1,
                        showTutorial: true,
                        backStyle: 1
                    };
                }

                GameManager.startGame();
            }
        );
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameVars.currentScene = scene;
    }

    public static onGameAssetsLoaded(): void {

        GameVars.gameText = GameVars.currentScene.cache.json.get("game-text")[GameVars.language];

        AudioManager.init();

        GameManager.enterSplashScene();
        // GameManager.enterBoardScene();
    }

    public static enterSplashScene(): void {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static enterBoardScene(): void {

        if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
            gdsdk.showAd();
        } else {
            GameVars.currentScene.scene.start("BoardScene");
        }
    }

    public static changeStyle(left: boolean): void {

        if (left) {
            GameVars.gameData.backStyle--;
        } else {
            GameVars.gameData.backStyle++;
        }

        if (GameVars.gameData.backStyle === 6) {
            GameVars.gameData.backStyle = 1;
        } else if (GameVars.gameData.backStyle === 0) {
            GameVars.gameData.backStyle = 5;
        }

        GameManager.writeGameData();

        BoardContainer.currentInstance.deckContainer.changeBack();
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    private static startGame(): void {

        GameVars.currentScene.scene.start("PreloadScene");
    }

    private static generateCardValues(): void {

        // esta funcion se deberia usar para cada partida
        // ver con cuantas barajas se juega
        GameVars.cards.length = 0;
    
        let value: string;

        for (let i = 0; i < 4; i++) {
            for (let j = 1; j < 14; j++) {

                if (j === 1) {
                    value = "A";
                } else if ( j === 11) {
                    value = "J";
                } else if ( j === 12) {
                    value = "Q";
                } else if ( j === 13) {
                    value = "K";
                } else {
                    value = j.toString();
                }

                GameVars.cards.push({value: value, suit: i});
            }
        }

        GameVars.cards = Phaser.Utils.Array.Shuffle(GameVars.cards);
    }

    private static getGameStorageData(key: string, successCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {

        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
